import { createSelector } from 'reselect';
import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericPost } from '@/_shared/types';
import { GenericApiError } from '@/_shared/types/apiError';
import { getCurrentOrganization } from '@/core/state';
import { API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_ID_NEXT_PATH_KEY } from '@/swagger/constants/surveys-keys';
import {
  API_POST_SURVEYS_CAMPAIGNS_ID_NEXT,
  KEY_POST_SURVEYS_CAMPAIGN_BY_ID_NEXT,
} from '../constats';
import { MOCK_RESPONSE_POST_SURVEYS_CAMPAIGN_BY_ID_NEXT } from '../mocks';

type PostSurveysCampaignByIdNext = GenericPost<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_ID_NEXT_PATH_KEY
>;

type RequestPostSurveysCampaignByIdNext = PostSurveysCampaignByIdNext['request']['body'] &
  PostSurveysCampaignByIdNext['request']['path'];

type ResponsePostSurveysCampaignByIdNext = PostSurveysCampaignByIdNext['response']['body'];

type CallParamsPostSurveysCampaignByIdNext = Omit<
  RequestPostSurveysCampaignByIdNext,
  'organizationId'
> & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

export type CallResponsePostSurveysCampaignByIdNext = ResponsePostSurveysCampaignByIdNext;

type CallErrorPostSurveysCampaignByIdNext = GenericApiError;

type CallSelectorsPostSurveysCampaignByIdNext = {
  activeStep: ResponsePostSurveysCampaignByIdNext;
};

export const postSurveysCampaignByIdNextCall = createGeneralCall<
  CallParamsPostSurveysCampaignByIdNext,
  CallResponsePostSurveysCampaignByIdNext,
  CallErrorPostSurveysCampaignByIdNext,
  CallSelectorsPostSurveysCampaignByIdNext
>({
  id: KEY_POST_SURVEYS_CAMPAIGN_BY_ID_NEXT,
  method: 'post',
  url:
    ({ payload }) =>
    state => {
      const org = getCurrentOrganization(state);
      return API_POST_SURVEYS_CAMPAIGNS_ID_NEXT(org, payload.id);
    },
  paramsSelector:
    ({ payload }) =>
    () =>
      payload,
  successMock: IS_MOCK_ENABLED({ avoidMockOnDemoMode: true })
    ? MOCK_RESPONSE_POST_SURVEYS_CAMPAIGN_BY_ID_NEXT
    : undefined,
  selectors: {
    activeStep: ({ selectors }) => createSelector(selectors.response, res => res || undefined),
  },
});
